import React, { useState, useEffect } from 'react';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAppId } from "../context/AppIdContext";
import '../style/boothPramukh.css'
import Header from '../component/header';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const BoothWiseVoters = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    // 1. Pull language from context
    const { appId, language } = useAppId();
    const navigate = useNavigate();

    // 2. Set default language to English
    const lang = language || 'en';

    // 3. Translation Dictionary
    const t = {
        en: {
            loadingData: "Loading Data...",
            pageTitle: "Booth Wise Voters",
            pageSubtitle: "Manage platform administrators and their permissions.",
            searchPlaceholder: "Search by Booth No...",
            boothNo: "Booth No.",
            totalVoters: "Voters :",
            noBoothFound: "No booth found matching",
            noDataAvailable: "No data available"
        },
        hi: {
            loadingData: "डेटा लोड हो रहा है...",
            pageTitle: "बूथ अनुसार मतदाता",
            pageSubtitle: "प्लेटफ़ॉर्म प्रशासकों और उनकी अनुमतियों का प्रबंधन करें।",
            searchPlaceholder: "बूथ नंबर द्वारा खोजें...",
            boothNo: "बूथ नं.",
            totalVoters: "मतदाता :",
            noBoothFound: "इससे मेल खाने वाला कोई बूथ नहीं मिला",
            noDataAvailable: "कोई डेटा उपलब्ध नहीं है"
        },
        gu: {
            loadingData: "ડેટા લોડ થઈ રહ્યો છે...",
            pageTitle: "બૂથ વાઈઝ મતદારો",
            pageSubtitle: "પ્લેટફોર્મ સંચાલકો અને તેમની પરવાનગીઓનું સંચાલન કરો.",
            searchPlaceholder: "બૂથ નંબરથી શોધો...",
            boothNo: "બૂથ નં.",
            totalVoters: "મતદારો :",
            noBoothFound: "કોઈ બૂથ મળ્યું નથી",
            noDataAvailable: "કોઈ ડેટા ઉપલબ્ધ નથી"
        }
    };

    const txt = t[lang];

    useEffect(() => {
        if (appId) {
            fetchUsers();
        } else {
            navigate("/");
        }
    }, [appId]);

    const fetchUsers = async () => {
        setLoading(true);
        try {
            const response = await axios.post(
                `${BASE_URL}/api/dis_total_booth`,
                { app_id: appId }
            );

            if (response.data.success && response.data.data && response.data.data.result) {
                setUsers(response.data.data.result);
            } else {
                setUsers([]);
            }
        } catch (err) {
            console.error("API Error:", err);
            setUsers([]);
        } finally {
            setLoading(false);
        }
    };

    // Filter Logic
    const filteredUsers = users.filter((user) => {
        if (!searchTerm) return true;
        return String(user.booth_no).toLowerCase().includes(searchTerm.toLowerCase());
    });

    // --- CLICK HANDLER ---
    const handleCardClick = (boothNo) => {
        navigate('/booth_wise_search', { state: { autoSearchBooth: boothNo } });
    };

    // --- NEW LOADING UI ---
    if (loading) {
        return (
            <div className="loader-wrapper">
                <div className="spinner"></div>
                <p className="loader-text">{txt.loadingData}</p>
                <style jsx>{`
                    .loader-wrapper {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        min-height: 60vh;
                        width: 100%;
                    }
                    .spinner {
                        width: 50px;
                        height: 50px;
                        border: 4px solid #E5E7EB;
                        border-top: 4px solid #2563EB;
                        border-radius: 50%;
                        animation: spin 1s linear infinite;
                        margin-bottom: 16px;
                        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
                    }
                    .loader-text {
                        color: #6B7280;
                        font-weight: 500;
                        font-size: 1.1rem;
                        animation: pulse 1.5s ease-in-out infinite;
                    }
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                    @keyframes pulse {
                        0%, 100% { opacity: 1; }
                        50% { opacity: 0.5; }
                    }
                `}</style>
            </div>
        );
    }

    return (
        <>
            <div className='app-container p-4'>

                {/* Header Component */}
                <Header title={txt.pageTitle} />

                {/* --- PROFESSIONAL FILTER CONTAINER --- */}
                <div className="filter-container-modern">
                    <div className="search-wrapper-modern mb-4">
                        <svg className="search-icon-modern" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <input
                            type="text"
                            className="search-input-modern"
                            placeholder={txt.searchPlaceholder}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>

                {/* Grid System - Shows 2 on mobile, 5 on full screen */}
                <div className="row g-4">
                    {filteredUsers.length > 0 ? (
                        <div className="row w-100 m-0">
                            {filteredUsers.map((user) => (
                                <div
                                    className="col-6 col-md-4 col-lg-3 col-xl-2-custom col-xxl-2-custom mb-4"
                                    key={user.id || user.booth_no}
                                >
                                    <div
                                        className="user-card h-100"
                                        onClick={() => handleCardClick(user.booth_no)}
                                        style={{ cursor: 'pointer', transition: 'transform 0.2s' }}
                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                    >
                                        <div className="menu-dots">
                                            <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                                                <path d="M12 13a1 1 0 100-2 1 1 0 000 2zM12 7a1 1 0 100-2 1 1 0 000 2zM12 19a1 1 0 100-2 1 1 0 000 2z" />
                                            </svg>
                                        </div>

                                        <h5 style={{ fontSize: '14px', color: 'var(--text-secondary)', marginBottom: '8px' }}>
                                            {txt.boothNo}
                                        </h5>

                                        <div className="booth-circle">
                                            {user.booth_no}
                                        </div>

                                        <h5 className="card-name text-primary" style={{ marginTop: '16px', fontSize: '16px' }}>
                                            <>{txt.totalVoters} <span style={{ color: 'var(--color-brand)' }}>{user.total_voter}</span></>
                                        </h5>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="col-12">
                            <div className="no-data-message">
                                <div className="no-data-icon">📭</div>
                                <div className="no-data-text">
                                    {searchTerm ? `${txt.noBoothFound} "${searchTerm}"` : txt.noDataAvailable}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <style jsx>{`
                /* --- PROFESSIONAL FILTER CONTAINER STYLING --- */
                .filter-container-modern {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    margin-bottom: 30px;
                }
                .search-wrapper-modern {
                    position: relative;
                    width: 100%;
                    max-width: 450px;
                }
                .search-icon-modern {
                    position: absolute;
                    left: 16px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #94a3b8;
                    width: 20px;
                    height: 20px;
                    pointer-events: none;
                }
                .search-input-modern {
                    width: 100%;
                    padding: 14px 16px 14px 48px;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    font-size: 15px;
                    color: #1e293b;
                    background-color: #ffffff;
                    outline: none;
                    transition: all 0.2s ease;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.02);
                }
                .search-input-modern:focus {
                    border-color: #2563eb;
                    box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
                    background-color: #fff;
                }

                /* No Data Message Styling */
                .no-data-message {
                    text-align: center;
                    padding: 60px 20px;
                    background: white;
                    border-radius: 16px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
                    margin: 20px 0;
                }

                .no-data-icon {
                    font-size: 64px;
                    margin-bottom: 16px;
                    opacity: 0.5;
                }

                .no-data-text {
                    font-size: 16px;
                    font-weight: 500;
                    color: #6b7280;
                }

                /* Custom column classes for 5 items per row */
                :global(.col-xl-2-custom) {
                    flex: 0 0 auto;
                    width: 20%;
                }
                
                :global(.col-xxl-2-custom) {
                    flex: 0 0 auto;
                    width: 20%;
                }

                @media (max-width: 1200px) {
                    :global(.col-xl-2-custom) {
                        width: 25%; /* 4 items on smaller screens */
                    }
                }

                @media (max-width: 992px) {
                    :global(.col-lg-3) {
                        width: 33.333%; /* 3 items on tablets */
                    }
                }

                @media (max-width: 768px) {
                    :global(.col-md-4) {
                        width: 33.333%; /* 3 items on small tablets */
                    }
                }

                @media (max-width: 640px) {
                    .filter-container-modern {
                        margin-bottom: 20px;
                    }
                    .search-wrapper-modern {
                        max-width: 100%;
                    }
                    .search-input-modern {
                        padding: 12px 16px 12px 42px;
                        font-size: 14px;
                    }
                    
                    /* Adjust card size for mobile to show 2 per row */
                    :global(.col-6) {
                        width: 50%; /* 2 items on mobile */
                    }
                    
                    .user-card {
                        padding: 16px 12px;
                    }
                    
                    .booth-circle {
                        width: 60px;
                        height: 60px;
                        font-size: 20px;
                        margin: 8px auto;
                    }
                    
                    .card-name {
                        font-size: 14px;
                        margin-top: 12px !important;
                    }

                    .no-data-message {
                        padding: 40px 16px;
                    }

                    .no-data-icon {
                        font-size: 48px;
                    }

                    .no-data-text {
                        font-size: 14px;
                    }
                }
            `}</style>
        </>
    );
};

export default BoothWiseVoters;